
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import eventTrackingFamilySiteFnMixins from '~/mixins/eventTrackingFamilySiteFnMixins.js';

export default {
  name: "HappyKidsPromotionDetail",
  mixins: [eventTrackingMixins, eventTrackingFamilySiteFnMixins],
  props: {
    data: {
        type: Object,
        default: () => ({})
    }
  },

  data() {
    return {
      promotion: null,
      loading: 0,
      isShowTermsAndConditions: false
    };
  },

  mounted() {
    console.debug('HappyKidsPromotionDetail mounted()...');

    // fire a function only when the modal is on screen.
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === this.data?.modalId) {
        console.debug('HappyKidsPromotionDetail mounted()...bv::modal::show', modalId);
        // delay 1 sec
        setTimeout(() => {
          this.$nextTick(() => {
            console.debug('ctaButton...');

            const ctaButtons = document.querySelectorAll('a.product-promo-modal-cta');
            console.debug('ctaButtons:', ctaButtons);
            ctaButtons.forEach((el) => {
              if (el.getAttribute('data-listener') === null) {
                el.setAttribute('data-listener', 'true')
                el.addEventListener('click', this.handleEventTracking_modalPromotionContent);
              }
            });
          });
        }, 1000);




      }
    });
  },

  methods: {
    getQueryStringValue(href, key) {
      const url = new URL(href);
      return url.searchParams.get(key);
    },
    handleEventTracking_modalPromotionContent(event) {
      try {
        console.debug(event);
        const aTag = event?.target?.closest('a');
        console.debug(aTag)
        console.debug(aTag?.attributes?.getNamedItem('data-modal-id')?.value)
        const modalId = aTag?.attributes?.getNamedItem('data-modal-id')?.value;
        const cardItem = document.getElementById(modalId);
        console.debug('cardItem:', cardItem);
        let sectionItem = cardItem.closest('.happy-kids-home-page-product-section');
        if (!sectionItem) {
          sectionItem = cardItem.closest('.ComponentFamilyCampaignProductSection');
        }
        console.log('sectionItem:', sectionItem);

        let sectionText = '';
        if (sectionItem && sectionItem.querySelector('h2')) {
          sectionText = sectionItem.querySelector('h2').innerText;
        }
        let categoryText = '';
        if (sectionItem && sectionItem.querySelector('.active')) {
          categoryText = sectionItem.querySelector('.active').innerText;
        }
        
  
        console.debug('handleEventTracking_modalPromotionContent()...');
        const dataFromClickedElement = this.extractDataFromClickedElement(cardItem, '.');
        const href = aTag?.href;
        console.debug('dataFromClickedElement:', dataFromClickedElement);
        const isProductPromoModalCta = aTag.classList.contains('product-promo-modal-cta');

        console.debug('#243 Modal');
        if (isProductPromoModalCta) {
          if (this.isTransitionLink(href)) {
  
            const insurerCode = this.data?.insurerCode
            // check the href for query string of "section" and "category".
            const section = this.getQueryStringValue(href, 'section') || sectionText
            const category = this.getQueryStringValue(href, 'category') || categoryText
            const eventTrackingParams = this.initEventTrackingParams()
            eventTrackingParams.a = 'click_redirection'
            eventTrackingParams.l = `${href}`
            eventTrackingParams.c = `happykidscamp_${section}_${category}_${insurerCode}_products_card_promo_${href}`
            eventTrackingParams.cd.product_category = category
            eventTrackingParams.cd.product_name = dataFromClickedElement?.card_title
            eventTrackingParams.cd.insurer_name = dataFromClickedElement?.insurer_name
            this.sendEventTracking(eventTrackingParams)
          }
        }

      } catch (error) {
        console.error('handleEventTracking_modalPromotionContent() error:', error);
        this.$sentry.captureException(error);
      }

    },

    showTermsAndConditions() {
      this.isShowTermsAndConditions = !this.isShowTermsAndConditions;
    }
  },
};
